import "./style.css?css";

export default function GreenGlow({ text, className }) {
  return <div className={`green-glow ${className ?? ""}`}>{text}</div>;
}
